export const ADMIN_GROUP = {
  SUPER_ADMIN: 1,
  SUPPORT: 2,
  GUARDIAO: 3,
};

export const ADMIN_ONLY = [ADMIN_GROUP.SUPER_ADMIN];
export const SUPPORT_AND_ABOVE = [ADMIN_GROUP.SUPER_ADMIN, ADMIN_GROUP.SUPPORT];
export const ALL_GROUPS = [
  ADMIN_GROUP.SUPER_ADMIN,
  ADMIN_GROUP.SUPPORT,
  ADMIN_GROUP.GUARDIAO,
];
